export default "__VITE_ASSET__c71dc2a6__"